import exportSettingsApi from '../../_api/exportSettings'
import i18n from '@/locales'

export default {
  fetchExportFields: async ({ commit, dispatch }) => {
    try {
      let response = {}
      response = await exportSettingsApi.getExportFields()
      commit('setExportFields', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'export_fetch_export_fields_error'
        },
        { root: true }
      )
    }
  },
  /* - File Formats  - */
  getFileFormat: async ({ commit, getters, dispatch }, id) => {
    try {
      let response = {}
      response = await exportSettingsApi.getFileFormat(id)
      commit('setFileFormat', response.data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'export_fetch_file_format_error' }, { root: true })
    }
  },
  fetchFileFormats: async (
    { commit, getters, dispatch },
    { pagination = true }
  ) => {
    try {
      const page = getters.fileFormatsCurrentPage
      const filters = getters.fileFormatsFilters
      let response = {}
      if (pagination) {
        response = await exportSettingsApi.getFileFormats(filters, true, page)
      } else {
        response = await exportSettingsApi.getFileFormats(filters, false, page)
      }
      const lastPage = response.headers['pagination-last-page']
      commit('setFileFormatsLastPage', lastPage)
      commit('setFileFormats', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'export_fetch_file_formats_error'
        },
        { root: true }
      )
    }
  },
  setFileFormatsFilters: async ({ commit, dispatch }, filters) => {
    commit('setFileFormatsFilters', filters)
    await dispatch('fetchFileFormats', { pagination: false })
  },
  nextFileFormatsPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingExportSettings) return
    commit('incrementFileFormatsCurrentPage')
    dispatch('fetchFileFormats')
  },
  updateFileFormat: async (
    { commit, dispatch, getters },
    fileFormat
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const response = await exportSettingsApi.putFileFormat(
        fileFormat.id,
        fileFormat.info
      )
      commit('addFileFormat', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('export_update_file_format_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_update_file_format_error' },
        { root: true }
      )
    } finally {
    }
  },
  createFileFormat: async (
    { commit, dispatch, getters },
    fileFormat
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const response = await exportSettingsApi.postFileFormat(fileFormat)
      commit('addFileFormat', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('export_create_file_format_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_create_file_format_error' },
        { root: true }
      )
    } finally {
    }
  },
  deleteFileFormat: async (
    { commit, dispatch, getters },
    fileFormatId
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      await exportSettingsApi.deleteFileFormat(fileFormatId)
      commit('deleteFileFormat', fileFormatId)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('export_delete_file_format_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'export_delete_file_format_error' },
        { root: true }
      )
    } finally {
    }
  },
  /* - Field Mappings - */
  fetchFieldsMapping: async (
    { commit, getters, dispatch },
    { pagination = true }
  ) => {
    try {
      const page = getters.fieldsMappingCurrentPage
      const filters = getters.fieldsMappingFilters
      let response = {}
      if (pagination) {
        response = await exportSettingsApi.getFieldsMapping(filters, true, page)
      } else {
        response = await exportSettingsApi.getFieldsMapping(filters, false, page)
      }
      const lastPage = response.headers['pagination-last-page']
      commit('setFieldsMappingLastPage', lastPage)
      commit('setFieldsMapping', response.data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'expense_fetch_fields_mapping_error' }, { root: true })
    }
  },
  getFieldMapping: async ({ commit, getters, dispatch }, id) => {
    try {
      let response = {}
      response = await exportSettingsApi.getFieldMapping(id)
      commit('setFieldMapping', response.data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'expense_fetch_fields_mapping_error' }, { root: true })
    }
  },
  setFieldsMappingFilters: async ({ commit, dispatch }, filters) => {
    commit('setFieldsMappingFilters', filters)
    await dispatch('fetchFieldsMapping', { pagination: false })
  },
  nextFieldsMappingPage: ({ commit, getters, dispatch }) => {
    if (getters.isCallingExportSettings) return
    commit('incrementFieldsMappingCurrentPage')
    dispatch('fetchFieldsMapping')
  },

  updateFieldMapping: async (
    { commit, dispatch, getters },
    fieldMapping
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const response = await exportSettingsApi.putFieldMapping(
        fieldMapping.id,
        fieldMapping.info
      )
      commit('addFieldMapping', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('expense_update_fields_mapping_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'expense_update_fields_mapping_error' },
        { root: true }
      )
    } finally {
    }
  },
  createFieldMapping: async (
    { commit, dispatch, getters },
    fieldMapping
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      const response = await exportSettingsApi.postFieldMapping(fieldMapping)
      commit('addFieldMapping', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('expense_create_fields_mapping_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'expense_create_fields_mapping_error' },
        { root: true }
      )
    } finally {
    }
  },
  deleteFieldMapping: async (
    { commit, dispatch, getters },
    fieldMappingId
  ) => {
    if (getters.isCallingExportSettings) return
    try {
      await exportSettingsApi.deleteFieldMapping(fieldMappingId)
      commit('deleteFieldMapping', fieldMappingId)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('expense_delete_fields_mapping_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'expense_delete_fields_mapping_error' },
        { root: true }
      )
    } finally {
    }
  },
  fetchErps: async (
    { commit, getters, dispatch },
    { pagination = true }
  ) => {
    try {
      const page = getters.erpsCurrentPage
      const filters = getters.erpsFilters
      let response = {}
      if (pagination) {
        response = await exportSettingsApi.getFileFormats(filters, true, page)
      } else {
        response = await exportSettingsApi.getFileFormats(filters, false, page)
      }
      const lastPage = response.headers['pagination-last-page']
      commit('setFileFormatsLastPage', lastPage)
      commit('setFileFormats', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'export_fetch_file_formats_error'
        },
        { root: true }
      )
    }
  },

  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
